import { render } from "./AppSupportTab.vue?vue&type=template&id=bca90acc&scoped=true"
import script from "./AppSupportTab.vue?vue&type=script&lang=js"
export * from "./AppSupportTab.vue?vue&type=script&lang=js"

import "./AppSupportTab.vue?vue&type=style&index=0&id=bca90acc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bca90acc"]])

export default __exports__